import getStatistics from "./statistics";
import getDashboard from "./dashboard";

export default {
  getStatistics,
  getDashboard
};
